import React from "react";
import {Progress} from "reactstrap";

const LEGACY_PROGRESS_LABELS = [
	"Missing Information",
	"Driving to Site",
	"On Site",
	"Finished Mandatory #1",
	"Finished Mandatory #2",
	"Finished Mandatory #3",
	"Finished Mandatory #4",
	"Finished Specific Notes",
	"Collected Feedback",
	"Off Site",
];

/**
 * Normalize API `{label, percent, complete}` or a legacy 0–10 score.
 * Scoring lives in PHP (`Ticket_Workflow_Progress`); this only renders.
 */
export function normalizeTicketProgress(progress) {
	if (progress == null || progress === "") {
		return null;
	}
	if (typeof progress === "object") {
		const nested = progress.progress && typeof progress.progress === "object"
			? progress.progress
			: progress;
		if (nested.label != null || nested.percent != null || nested.complete != null) {
			const percent = Number(nested.percent);
			return {
				label: nested.label || (nested.complete ? "Off Site" : "In Progress"),
				percent: Number.isFinite(percent) ? percent : (nested.complete ? 100 : 0),
				complete: !!nested.complete,
			};
		}
		if (nested.progress != null && typeof nested.progress !== "object") {
			return normalizeTicketProgress(nested.progress);
		}
	}
	const n = Number(progress);
	if (Number.isNaN(n)) {
		return {label: String(progress), percent: 0, complete: false};
	}
	return {
		label: LEGACY_PROGRESS_LABELS[n] || `Step ${n}`,
		percent: Math.floor((n / 10) * 100),
		complete: n >= 10,
	};
}

export function formatTicketProgressText(progress) {
	const normalized = normalizeTicketProgress(progress);
	if (!normalized) {
		return "-";
	}
	return `${normalized.label} (${normalized.percent}%)`;
}

export default function TicketProgressDisplay({
	progress,
	emptyLabel = "N/A",
	showActive = false,
	titleSize = "12px",
	barFontSize = "14px",
}) {
	const normalized = normalizeTicketProgress(progress);
	if (!normalized) {
		return <b>{emptyLabel}</b>;
	}
	return (
		<div>
			<b style={{
				fontSize: titleSize,
				fontStyle: normalized.complete ? "normal" : "italic",
			}}>
				{normalized.label}
				{showActive && !normalized.complete ? (
					<b style={{fontSize: titleSize, color: "darkgreen"}}> - ACTIVE</b>
				) : null}
			</b>
			<Progress value={normalized.percent} max={100} color="success">
				<p style={{
					color: "black",
					top: "8px",
					position: "relative",
					fontSize: barFontSize,
				}}>
					{normalized.percent}%
				</p>
			</Progress>
		</div>
	);
}
